// src/components/biometrics/useBiometricsData.ts
import { useEffect, useState } from "react";
import { isApiBiometricsResponse, isError, mapApiToUi, mapLegacyToUi } from "./mappers";
import { ApiBiometricsResponse, UiBiometricsData } from "../types/types";
import { analysisService } from "../../../shared/services/api/analysis/analysisService";
import { IBiometricsData } from "../../../shared/services/api/analysis/types/biometrics";

export function useBiometricsData(isOpen: boolean, biometricsId: string) {
	const [data, setData] = useState<UiBiometricsData | null>(null);
	const [loading, setLoading] = useState(false);
	const [photoError, setPhotoError] = useState(false);

	useEffect(() => {
		if (!isOpen) return;
		let mounted = true;
		setLoading(true);
		setPhotoError(false);

		analysisService
			.getBiometryData(biometricsId) // Promise<Error | IBiometricsData> no seu projeto
			.then((value: Error | IBiometricsData) => {
				if (!mounted) return;
				if (isError(value)) {
					setData(null);
					return;
				}
				const ui = isApiBiometricsResponse(value as any) ? mapApiToUi(value as unknown as ApiBiometricsResponse) : mapLegacyToUi(value);
				setData(ui || null);
			})
			.catch(() => mounted && setData(null))
			.finally(() => mounted && setLoading(false));

		return () => {
			mounted = false;
		};
	}, [isOpen, biometricsId]);

	return { data, loading, photoError, setPhotoError };
}
